import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1905fc81")

_pushScopeId("data-v-1905fc81")
const _hoisted_1 = { class: "toc_loopCarVideo_main" }
const _hoisted_2 = { class: "toc_loopCarVideo_body" }
const _hoisted_3 = { class: "toc_loopCarVideo_body_cont" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "comTitle_main" }, [
  /*#__PURE__*/_createVNode("div", { class: "comTitle_left" }, "环车视频")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "video-tab-list"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetectPlayer = _resolveComponent("DetectPlayer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.state.videoInfo.length > 1)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.videoInfo, (video, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: video.videoCode,
                  class: ["video-tab-item", { 'video-tab-item_active': _ctx.state.currentVideoIndex === index }],
                  onClick: ($event: any) => (_ctx.switchTab(index))
                }, _toDisplayString(video.videoName), 11, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DetectPlayer, {
          class: "DetectPlayer",
          "play-data": _ctx.state.playData
        }, null, 8, ["play-data"])
      ])
    ])
  ]))
})